const isEmpty = (object) => !object || Object.keys(object).length < 1
export default isEmpty